/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 使用手机号验证码获取token信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  oauthPhoneCaptchaDto: oauth2.OauthPhoneCaptchaDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.Token;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/token-sms`,
    data: oauthPhoneCaptchaDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
